<template>
  <div
    class="boss-message-mail-body pega-pre-wrap"
    data-test="body"
    v-html="$sanitize(renderBody)"
  />
</template>

<script>
import util from '@/lib/util'

export default {
  props: {
    body: {
      type: String,
      default: ''
    },
    isRemindMail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderBody () {
      // URLが指定されている場合ハイパーリンクにする変換
      // 選考リマインドメールの地図[map]をgoogleMapのリンクで掲出する変換
      return this.isRemindMail ? util.replaceMapLink(util.replaceAddressAndUrlLink(this.body)) : util.replaceAddressAndUrlLink(this.body)
    }
  }
}
</script>
